const zIndexMap = {
  FULLSCREEN_CARD: 3,
  MEDIUM_ZOOM_OVERLAY: 4,
  MEDIUM_ZOOM_IMAGE: 5,
}

export default zIndexMap
